export default __webpack_public_path__ + "static/media/property_436.78f41faf.png";